import { useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { captureException } from '@sentry/browser';
import { useChannelStateContext } from './streamHooks';
import { useProfile } from '../../../api/user/profile';
import { getProcUserId } from '../utils';
import {
  NotifySpRoomAboutNewMessage,
  NotifySpRoomAboutNewMessageVariables,
} from '../../../api/types/NotifySpRoomAboutNewMessage';
import { NOTIFY_SP_ROOM } from '../queries/notifySpRoom';
import { messageTypesToNotify } from '../Message/realMessageTypes';

export const useAutoNotifySpRoom = () => {
  const { channel } = useChannelStateContext();
  const { user_id: userId } = useProfile();
  const [notifySpRoom, { error }] = useMutation<
    NotifySpRoomAboutNewMessage, NotifySpRoomAboutNewMessageVariables
    >(NOTIFY_SP_ROOM);

  useEffect(() => {
    // As we don't show this error on UI we have to catch it to sentry
    if (error) {
      captureException(error);
    }
  }, [error]);

  useEffect(() => {
    const listener = channel.on('message.new', ({ user, message }) => {
      if (userId === getProcUserId(user?.id!)
        && message?.id
        && messageTypesToNotify.includes(message.type!)
      ) {
        notifySpRoom({
          variables: { messageId: message.id },
        });
      }
    });

    return () => {
      listener.unsubscribe();
    };
  }, [channel, userId, notifySpRoom]);
};
